import "./App.css";
import Layout from "./components/layout/Layout";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAuthenticated } from "./redux/actions/providerActions";

//Matertial Ui
import { SnackbarProvider, useSnackbar } from "notistack";

import axios from "axios";
import Cookie from "js-cookie";
axios.defaults.baseURL = "https://oneclick-back.herokuapp.com/api";

if (Cookie.get("refreshToken")) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${Cookie.get(
        "refreshToken"
    )}`;
} else {
    axios.defaults.headers.common["Authorization"] = null;
}

function MyApp(props) {
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log(props.errors);
        if (props.errors !== null) {
            console.log(JSON.stringify(props.errors));
            Object.keys(props.errors).map((each) => {
                enqueueSnackbar(`${each}: ${props.errors[each]}`, {
                    variant: "error",
                    autoHideDuration: 5000,
                });
                return null;
            });
        }
    }, [props.errors, enqueueSnackbar]);

    return <></>;
}

function App(props) {
    useEffect(() => {
        const firstLogin = localStorage.getItem("firstLogin");
        if (firstLogin) {
            props.setAuthenticated();
        }
    });

    return (
        <div className="App">
            <SnackbarProvider
                maxSnack={10}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
            >
                <Layout />
                <MyApp errors={props.errors} />
            </SnackbarProvider>
        </div>
    );
}

const mapStateToProps = (state) => ({
    errors: state.provider.errors,
});

export default connect(mapStateToProps, { setAuthenticated })(App);
